import script from "./RoutesServedIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutesServedIndex.vue?vue&type=script&setup=true&lang=ts"

import "./RoutesServedIndex.vue?vue&type=style&index=0&id=0ee1efa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee1efa0"]])

export default __exports__